import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BroadcastService from '@common/services/broadcast.service';
import { UserStatusService } from '@common/services/user-status.service';
import VueClipboard from 'vue-clipboard2'
import Antd from 'ant-design-vue';
import VideoPlayer from 'vue-video-player'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import { SubMicroAppDealService } from '@common/services/sub-micro-app-deal.service';
import './public-path' //引入
// 全局变量
import { PublicParamsService } from '@common/services/public-params.service';
import { FixedParamsService } from '@common/services/fixed-params.service';


import '@common/services/common-component-register.service.js';    // 全局组件、指令注册

// 字典过滤器
import '@common/filters/dictionary.filter';

// 公共样式
import 'ant-design-vue/dist/antd.css';
import '@common/css/reset.css'
import '@common/css/public.less'
import '@common/css/antd-reset.less'

import {handleDrag}  from "@/utils/DraggableResizable";
import thousands from './utils/thousands'
import FormInput from "@components/form-input/form-input.vue"; // 表单组件
// import './public-path' //引入
import "@src/assets/css/index.less";

Vue.prototype.DraggableResizable = handleDrag;
Vue.prototype.thousands = thousands;
// 设置变量
Vue.config.productionTip = false
Vue.prototype.$baseUrl = process.env.VUE_APP_PROXY
Vue.prototype.$broadcast = BroadcastService;

Vue.component('FormInput', FormInput)



Vue.use(Antd).use(VueClipboard).use(VideoPlayer)
Vue.use(VueDirectiveImagePreviewer, {
  zIndex: 9999,  //层级显示
})
// 初始化rem - 移动端使用
// RemService.initRem(document,window);

// 微前端相关配置
SubMicroAppDealService.init(render);
export async function bootstrap () {
  SubMicroAppDealService.bootstrap();
}
export async function mount (props) {
  SubMicroAppDealService.mount(props);
}
export async function unmount () {
  SubMicroAppDealService.unmount();
}


// 初始化

// 初始化
function render (props = {}) {
  const { container } = props
  FixedParamsService.parentAction = props.parentAction;
  return new Vue({
    router,
    store,
    data : () => {
      return {
        parentAction : FixedParamsService.parentAction,
        // 全局变量
        PPService : new PublicParamsService()
      }
    },
    render: h => h(App)
  }).$mount(container ? container.querySelector('#lib') : '#lib')
}